// Flutter App Navigation Utilities
// This module provides functions to navigate from the React landing page to the Flutter app

export interface FlutterAppRoutes {
  login: string;
  signup: string;
  courses: string;
  dashboard: string;
  profile: string;
}

export const FLUTTER_APP_ROUTES: FlutterAppRoutes = {
  login: '/login',
  signup: '/signup', 
  courses: '/main?tab=0',
  dashboard: '/main',
  profile: '/profile'
};

export const APP_BASE_URL = '/app/';

/**
 * Navigate to the Flutter app login page
 */
export const navigateToFlutterLogin = (): void => {
  window.location.href = `${APP_BASE_URL}#${FLUTTER_APP_ROUTES.login}`;
};

/**
 * Navigate to the Flutter app signup page
 */
export const navigateToFlutterSignup = (): void => {
  window.location.href = `${APP_BASE_URL}#${FLUTTER_APP_ROUTES.signup}`;
};

/**
 * Navigate to the Flutter app courses page
 */
export const navigateToFlutterCourses = (): void => {
  window.location.href = `${APP_BASE_URL}#${FLUTTER_APP_ROUTES.courses}`;
};

/**
 * Navigate to the Flutter app dashboard
 */
export const navigateToFlutterDashboard = (): void => {
  window.location.href = `${APP_BASE_URL}#${FLUTTER_APP_ROUTES.dashboard}`;
};

/**
 * Navigate to the Flutter app profile page
 */
export const navigateToFlutterProfile = (): void => {
  window.location.href = `${APP_BASE_URL}#${FLUTTER_APP_ROUTES.profile}`;
};

/**
 * Navigate to a custom Flutter app route
 * @param route - The route path (without the base URL)
 */
export const navigateToFlutterApp = (route: string = ''): void => {
  const fullRoute = route ? `#${route}` : '';
  window.location.href = `${APP_BASE_URL}${fullRoute}`;
};

/**
 * Check if the Flutter app is available
 * This can be used to conditionally show Flutter app navigation
 */
export const isFlutterAppAvailable = (): boolean => {
  // In production, you might want to check if the app endpoint responds
  // For now, we'll assume it's always available
  return true;
};

/**
 * Get the full URL for a Flutter app route
 * @param route - The route path
 * @returns The complete URL
 */
export const getFlutterAppUrl = (route: keyof FlutterAppRoutes): string => {
  return `${window.location.origin}${APP_BASE_URL}#${FLUTTER_APP_ROUTES[route]}`;
};

/**
 * Open Flutter app in new tab/window
 * @param route - The route to open
 * @param newWindow - Whether to open in new window (default: new tab)
 */
export const openFlutterAppInNewTab = (route: keyof FlutterAppRoutes = 'dashboard', newWindow: boolean = false): void => {
  const url = getFlutterAppUrl(route);
  const target = newWindow ? '_blank' : '_blank';
  const features = newWindow ? 'width=1200,height=800,scrollbars=yes,resizable=yes' : undefined;
  
  window.open(url, target, features);
};
